import { render, staticRenderFns } from "./game-fps-item.vue?vue&type=template&id=d44784a8&scoped=true&"
import script from "./game-fps-item.vue?vue&type=script&lang=js&"
export * from "./game-fps-item.vue?vue&type=script&lang=js&"
import style0 from "./game-fps-item.vue?vue&type=style&index=0&id=d44784a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44784a8",
  null
  
)

export default component.exports